import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { buildNumber } from 'src/version';

Sentry.init({
  dsn: 'https://008ee656009f46148a2c174c41df17d6@sentry.io/4303717',
  environment: 'production',
  // @ts-ignore
  release: `sampleliste@${buildNumber !== '#{Build.BuildNumber}#' ? buildNumber : 'dev'}`,
});

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor() {}
  handleError(error) {
    const eventId = Sentry.captureException(error.originalError || error);
    Sentry.showReportDialog({ eventId });
  }
}
